import { 
    GET_AGENDA
} from '../types';


export default function agendaReducer(state={},action){
    switch(action.type){
        case GET_AGENDA:
            return { ...state, agenda: action.payload }
        default:
            return state
    }
}